var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFoodImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 38,
    stroke: "#E52333",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3592_1195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6328 37.1328L39.8672 37.1328L39.8672 22.3672C39.8672 21.6121 39.2551 21 38.5 21C37.7449 21 37.1328 21.6121 37.1328 22.3672L37.1328 37.1328L22.3672 37.1328C21.6121 37.1328 21 37.7449 21 38.5C21 39.2551 21.6121 39.8672 22.3672 39.8672L37.1328 39.8672L37.1328 54.6328C37.1328 55.3879 37.7449 56 38.5 56C39.2551 56 39.8672 55.3879 39.8672 54.6328L39.8672 39.8672L54.6328 39.8672C55.3879 39.8672 56 39.2551 56 38.5C56 37.7449 55.3879 37.1328 54.6328 37.1328Z",
    fill: "#E52333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3592_1195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFoodImg);
export default __webpack_public_path__ + "static/media/AddFoodImg.d22c951b94c04ae975dfc7b66be1d5fe.svg";
export { ForwardRef as ReactComponent };